import styled from "styled-components";

export const ListButtons = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.6rem;
	margin: 0 0 0 0.6rem;

	@media (max-width: 425px) {
		// Mobile L
		flex-wrap: wrap;
	}
`;
